import { Link } from "react-router-dom";

export default function Breadcrumb({ items }: { items: { label: string; path?: string }[] }) {
  return (
    <nav className="flex items-center gap-1.5 text-xs md:text-sm text-foreground-500 flex-wrap" aria-label="面包屑">
      {items.map((item, idx) => (
        <span key={idx} className="flex items-center gap-1.5">
          {item.path ? (
            <Link to={item.path} className="hover:text-primary-600 transition-colors whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800 whitespace-nowrap">{item.label}</span>
          )}
          {idx < items.length - 1 && <i className="ri-arrow-right-s-line text-foreground-300" />}
        </span>
      ))}
    </nav>
  );
}